export const environment = {
  production: true,
  BASE_URL: 'https://backend-test.goldentaxi.com.br/api/v1/golden-taxi',
  WS_URL: 'https://backend-test.goldentaxi.com.br',
};
